<template>
  <div class="container">
    <div class="slogan">Выше только небо</div>
    <img src="/static/images/nebo-logo-mobile.svg" alt="Logo" class="logo">
  </div>
</template>

<script>
  export default {
    name: "AsideMobile"
  }
</script>

<style scoped lang="stylus">
  @import '../styles/tools'
  .slogan
    font-family GraphikLCG
    font-size 18px
    text-transform uppercase
    color $white
    transform rotate(-90deg)
    width 300px
    margin-bottom 200px

  .logo
    width 70px
    height 70px

</style>